// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ValueType } from '../../../cogo/renderpack/v1/value-type.js';


export class PropOp {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):PropOp {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPropOp(bb:flatbuffers.ByteBuffer, obj?:PropOp):PropOp {
  return (obj || new PropOp()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPropOp(bb:flatbuffers.ByteBuffer, obj?:PropOp):PropOp {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PropOp()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

nodeIndex():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

kind():string|null
kind(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
kind(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

key():string|null
key(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
key(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

valueType():ValueType {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readInt8(this.bb_pos + offset) : ValueType.None;
}

stringValue():string|null
stringValue(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
stringValue(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

numberValue():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
}

booleanValue():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

static startPropOp(builder:flatbuffers.Builder) {
  builder.startObject(7);
}

static addNodeIndex(builder:flatbuffers.Builder, nodeIndex:number) {
  builder.addFieldInt32(0, nodeIndex, 0);
}

static addKind(builder:flatbuffers.Builder, kindOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, kindOffset, 0);
}

static addKey(builder:flatbuffers.Builder, keyOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, keyOffset, 0);
}

static addValueType(builder:flatbuffers.Builder, valueType:ValueType) {
  builder.addFieldInt8(3, valueType, ValueType.None);
}

static addStringValue(builder:flatbuffers.Builder, stringValueOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, stringValueOffset, 0);
}

static addNumberValue(builder:flatbuffers.Builder, numberValue:number) {
  builder.addFieldFloat64(5, numberValue, 0.0);
}

static addBooleanValue(builder:flatbuffers.Builder, booleanValue:boolean) {
  builder.addFieldInt8(6, +booleanValue, +false);
}

static endPropOp(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createPropOp(builder:flatbuffers.Builder, nodeIndex:number, kindOffset:flatbuffers.Offset, keyOffset:flatbuffers.Offset, valueType:ValueType, stringValueOffset:flatbuffers.Offset, numberValue:number, booleanValue:boolean):flatbuffers.Offset {
  PropOp.startPropOp(builder);
  PropOp.addNodeIndex(builder, nodeIndex);
  PropOp.addKind(builder, kindOffset);
  PropOp.addKey(builder, keyOffset);
  PropOp.addValueType(builder, valueType);
  PropOp.addStringValue(builder, stringValueOffset);
  PropOp.addNumberValue(builder, numberValue);
  PropOp.addBooleanValue(builder, booleanValue);
  return PropOp.endPropOp(builder);
}
}
